module.exports = __webpack_public_path__ + "static/handsUp.6c312fc4.svg";